export type TValidationType =
  | 'date'
  | 'number'
  | 'amount'
  | 'required'
  | 'currentcharges'
  | 'unknown';

export enum ValidationDismissalReason {
  NOT_PRINTED = 'NOT PRINTED',
  NOT_FOUND = 'NOT FOUND',
  NOT_READABLE = 'NOT READABLE',
  INCORRECT_VALIDATION = 'INCORRECT VALIDATION',
}

export interface IValidation {
  id: number;
  label: string;
  error: string | null;
  error_detail: string | null;
  dataset: 'extracted' | 'transformed' | 'schematized' | null;
  dismissal_reason: ValidationDismissalReason | null;
}

export interface IValidationForExtraction {
  id: string;
  results: IValidation[];
}

export interface IValidationEndpointResponse {
  status: string;
  isSuccess: boolean;
  data: IValidationForExtraction;
}

export interface ColorMap {
  standard: IColorMapSection;
  accessibility: IColorMapSection;
}
export interface IColorMapSection {
  invalid: IColorMapFields;
  missing: IColorMapFields;
  columnSelected: IColorMapFields;
  inactive: IColorMapFields;
  transparent: IColorMapFields;
}
export interface IColorMapFields {
  backgroundColor: string;
  color?: string;
  gridColor?: string;
}

export interface IValidationErrorByExtractionDetails {
  id: number;
  field: string;
  error: string | null;
  errorDetail: string | null;
  type: TValidationType;
  dataset?: string;
  dismissalReason?: ValidationDismissalReason | null;
}
export interface IValidationErrorByExtraction {
  extractionId: string;
  hasValidationResponse: boolean;
  validationErrorsList: TValidationType[];
  validationErrorDetails: IValidationErrorByExtractionDetails[];
}
// FIXME: Set to correct type for react query `useQueries` response
export type IValidationReactQueries = any;
